// extracted by mini-css-extract-plugin
export var logoWallButton = "index-module--logoWallButton--A5lAv";
export var logoWallContainer = "index-module--logoWallContainer--kXlkQ";
export var searchButton = "index-module--searchButton--w8Sht";